export const VIEWITEM_FILTER_EXPRESSIONS_LOCALSTORAGE_KEY = 'viewitemFilterExpressions';

export const VIEWITEM_FILTER_EXPRESSIONS_GENERATED = 'VIEWITEM_FILTER_EXPRESSIONS_GENERATED';
